import {environment} from "../../environments/environment";

export function getCurrencySymbolFromProjectID(projectID: string): string {

    switch (projectID) {
        case environment.hivPDSID.toString(): return 'Ksh';
        case environment.za_hivPDSID.toString(): return 'R';
        case environment.rw_ncdSanofiID.toString(): return 'RWF';
        case environment.rw_pdsID.toString(): return 'RWF';
        default: return 'Ksh';
    }

}